var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-upload",on:{"click":_vm.clickEvent}},[_c('image-base',{attrs:{"src":"/img/icon/upload.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }